module.exports = __webpack_public_path__ + "img/immagine-sfondo-emt.90f258ad.png";